import React, { useEffect, useState } from 'react'; 
import { FaUserAlt, FaPhoneAlt, FaEnvelope, FaUserShield, FaBriefcase } from 'react-icons/fa'; 
import { Link } from 'react-router-dom'; 
import { toast } from 'react-toastify'; 
import { useTheme } from '../contexts/ThemeContext';
import 'react-toastify/dist/ReactToastify.css'; 
import axios from '../config/axiosConfig';
import { motion } from 'framer-motion';

const UserCard = () => { 
  const [userData, setUserData] = useState(null); 
  const [isLoading, setIsLoading] = useState(true);
  const { darkMode } = useTheme(); 

  const fetchUserData = async () => { 
    try { 
      const response = await axios.get('/users/me'); 
      setUserData(response.data); 
    } catch (error) { 
      console.error('Erreur lors de la récupération des données utilisateur:', error); 
      toast.error("Erreur lors de la récupération des données utilisateur.", { 
        position: "top-center", 
        autoClose: 5000, 
      }); 
    } finally { 
      setIsLoading(false); 
    } 
  };

  useEffect(() => { 
    fetchUserData(); 
  }, []);

  useEffect(() => {
    const toastShown = localStorage.getItem('toastShown');
    if (userData && !toastShown) {
      toast.success(`Bienvenue ${userData.nom} ${userData.prenom}! Vous êtes maintenant inscrit en tant que ${userData.role}.`, { 
        position: "top-center",
        autoClose: 5000,
        onClose: () => localStorage.setItem('toastShown', 'true')
      });
    } 
  }, [userData]);

  if (isLoading) { 
    return (
      <div className="p-4 text-center">
        <span className="text-gray-400">Chargement...</span>
      </div>
    ); 
  }

  if (!userData) { 
    return (
      <div className="p-4 text-center text-red-600">
        <span>Aucune donnée utilisateur disponible</span>
      </div>
    ); 
  }

  const userDetails = [
    { title: 'Nom & Prénom', value: `${userData.nom} ${userData.prenom}`, icon: <FaUserAlt className="text-2xl text-blue-500" /> },
    { title: 'Téléphone', value: userData.phoneNumber || 'Numéro de téléphone indisponible', icon: <FaPhoneAlt className="text-2xl text-green-500" /> },
    { title: 'Email', value: userData.email || 'Email indisponible', icon: <FaEnvelope className="text-2xl text-purple-500" /> },
    { title: 'Rôle', value: userData.role || 'Rôle indisponible', icon: <FaUserShield className="text-2xl text-orange-500" /> },
    { title: 'Pesas', value: userData.pesas || 'Pesas indisponibles', icon: <FaBriefcase className="text-2xl text-yellow-500" /> },
  ];

  return (
    <motion.div 
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="bg-gray-800 shadow-lg rounded-lg p-3 text-gray-200 w-full max-w-xs"
      
    >
      <h2 className="text-xl font-semibold mb-4 flex items-center text-white">
        <FaUserAlt className="mr-2 text-yellow-500" />
        
        Informations Utilisateur
      </h2>
      
      <div className="space-y-3">
        {userDetails.map((detail, index) => (
          <motion.div 
            key={index} 
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.3 }}
            className="bg-gray-700 p-3 rounded-lg shadow-lg"
          >
            <div className="flex items-center space-x-4">
              {detail.icon}
              <div className="text-lg text-white font-semibold">{detail.title}</div>
            </div>
            <p className="text-sm text-gray-400 mt-2">{detail.value}</p>
          </motion.div>
        ))}
      </div>

      <div className="mt-4 text-center">
        <Link
          to="/users/me"
          className="w-full bg-blue-600 text-white py-2 px-4 rounded flex items-center justify-center hover:bg-blue-700 transition-colors"
        >
          Modifier mon profil
        </Link>
      </div>
    </motion.div>
  );
};

export default UserCard;
